import { createStore as createReduxStore, applyMiddleware } from "redux";
import { composeWithDevTools } from "redux-devtools-extension/developmentOnly";
import thunk from "redux-thunk";
import { createLogger } from "redux-logger";
import rootStore from "./reducers";
import promiseMiddleware from "redux-promise-middleware";
import { reactReduxFirebase } from "react-redux-firebase";
import { persistStore } from "redux-persist";
import actors from "./actors";
import subscribe from "redux-actors";
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import "firebase/compat/database";
import "firebase/compat/storage";
import { firebasePermissionDeniedMiddleware } from "./firebasePermissionDenied";
import { bootstrapAuthAccessTokenCache } from "./firebaseToken";
import { watchPersistRehydrateTimeout } from "./staleAuthRecovery";
const createStore = (initialState, firebaseConfig) => {
  const middlewares = [thunk, promiseMiddleware(), firebasePermissionDeniedMiddleware()];

  if (__DEV__) {
    middlewares.push(createLogger());
  }

  const composeEnhancers = composeWithDevTools({
    // options like actionSanitizer, stateSanitizer
  });

  if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig);
    bootstrapAuthAccessTokenCache();
  }

  const reduxFirebaseConfig = {
    enableLogging: false,
    attachAuthIsReady: true,
    updateProfileOnLogin: false,
    preserveOnLogout: ["global"],
  };

  let store = createReduxStore(
    rootStore,
    initialState,
    composeEnhancers(
      applyMiddleware(...middlewares),
      reactReduxFirebase(firebase, reduxFirebaseConfig)
    )
  );
  persistStore(store, null);
  watchPersistRehydrateTimeout(store);
  subscribe(store, actors);
  return store;
};

export default createStore;
